## Hawtio Help

Hawtio is a lightweight and modular Web console for managing Java and JVM applications.

### Plugin help

Browse the available help topics for plugin specific documentation using the help navigation bar.

### Further reading

- [Hawtio](https://hawt.io 'Hawtio') website
- Help improve Hawtio by [contributing](https://hawt.io/docs/contributing/)
- Hawtio on [GitHub](https://github.com/hawtio/hawtio)
